Vendd.Scripts.load(function () {

    $('.x-control.x-map-directions[data-control="map-directions"]').each(function (i, wrapper) {

        var $wrapper = $(wrapper);

        var $searchField = $('*[data-input="postcode"]', $wrapper);

        var $goButton = $('*[data-button="submit"]', $wrapper);
        var $goCarButton = $('*[data-button="bycar"]', $wrapper);
        var $goBusButton = $('*[data-button="bybus"]', $wrapper);
        var $goFootButton = $('*[data-button="byfoot"]', $wrapper);

        var latitude = $wrapper.data('latitude');
        var longitude = $wrapper.data('longitude');

        var connectedMapId = $wrapper.data('map');

        var $map = $('.x-control.x-map[data-control="map"][data-map="' + connectedMapId + '"]');

        var $tmplDiv = $('*[data-div="template"]', $wrapper);
        var $tmplDirections = $('*[data-div="directions"]', $wrapper);

        var writeResponse = function (response) {
            $tmplDirections.html('');

            var $ul = $('<ul />');
            if (response.routes.length > 0) {
                var route = response.routes[0];
                if (route.legs.length > 0) {
                    var leg = route.legs[0];
                    if (leg.steps.length > 0) {
                        $(leg.steps).each(function (r, rr) {
                            $ul.append($('<li />').html(rr.instructions));
                        });
                    }
                }
            }
            $tmplDirections.append($ul);
        };

        var getDirections = function (type) {
            if ($searchField.val() !== '') {
                var geocoder = new google.maps.Geocoder();
                geocoder.geocode({ 'address': $searchField.val() + ' GR' }, function (results, status) {
                    if (status == google.maps.GeocoderStatus.OK) {

                        var latLng = results[0].geometry.location;
                        var toLatLng = new google.maps.LatLng(latitude, longitude);
                        var directionsDisplay = new google.maps.DirectionsRenderer();
                        var directionsService = new google.maps.DirectionsService();

                        var request = {
                            origin: latLng,
                            destination: toLatLng,
                            travelMode: type
                        };

                        directionsDisplay.setMap($map.get(0).map.map);

                        directionsService.route(request, function (response, status) {

                            if (status == google.maps.DirectionsStatus.OK) {

                                directionsDisplay.setDirections(response);

                                writeResponse(response);
                            }
                            else if (status == google.maps.DirectionsStatus.ZERO_RESULTS) {
                                alert('no directions found');
                            }
                        });
                    } else {
                        throw new Error('could not get directions');
                    }
                });
            }
        }

        $goButton.click(function () {
            getDirections(google.maps.TravelMode.DRIVING);
        });

        $goCarButton.click(function () {
            getDirections(google.maps.TravelMode.DRIVING);
        });

        $goBusButton.click(function () {
            getDirections(google.maps.TravelMode.TRANSIT);
        });

        $goFootButton.click(function () {
            getDirections(google.maps.TravelMode.WALKING);
        });
    });
});